var SCM = SCM || {};

SCM.Announce = (function ($) {
    var ALERT_DELAY = 100;

    // Self-executing DOMReady primer for every role="alert" on the page. Runs
    // regardless of whether the client calls SCM.Announce.init() — no dependency
    // on a client's init sequence. AJAX-inserted elements skip this on purpose;
    // they get seeded by _alert's fallback on first use instead.
    //
    // Registered BEFORE the return so it's reached during IIFE execution — an
    // expression statement placed after `return` would be unreachable code and
    // dropped by the minifier (function declarations further down are safe
    // because they get hoisted).
    $(function () {
        $('[role="alert"]').each(function () {
            _prime($(this));
        });
    });

    return {
        init: _init,
        alert: _alert,
        clear: _clear
    };

    function _init() {
        // Server-rendered errors with content on first paint (login errors, reset password, etc.)
        // opt in to a11y announcement via .js-a11y-alert. Prime each so Chrome/Firefox
        // announce the role and the reannounce cache captures the original text.
        $('.js-a11y-alert').each(function () {
            _prime($(this));
        });
    }

    function _alert($el, message) {
        // Defensive fallback for elements that weren't reached by the DOMReady
        // primer (dynamically-injected alerts, ad-hoc consumers). Alerts primed
        // at init already have this data set from their original content, so
        // this call is a no-op for them.
        _captureOriginal($el);
        if (message === undefined) {
            message = $el.data('scmAnnounceText');
        }
        $el.empty().removeAttr('role').show();
        setTimeout(function () {
            $el.attr('role', 'alert').html(message);
        }, ALERT_DELAY);
    }

    function _clear($el) {
        $el.removeAttr('role').empty().hide();
    }

    // Capture the element's original server-rendered content into the reannounce
    // cache BEFORE any interaction JS runs, then do the Chrome/Firefox role-toggle
    // dance so browsers announce the initial alert. Called at DOMReady on every
    // role="alert" (and .js-a11y-alert opt-in) element — makes the cache immune
    // to any later out-of-band DOM writes, not just the ones that go through
    // SCM.Announce itself. Fixes the order-dependent server-then-format bug where
    // a no-message _alert call could otherwise read polluted content back out.
    function _prime($el) {
        if ($.trim($el.text()).length === 0) {
            return;
        }
        // Idempotent: if the cache is already seeded, this element was
        // already primed. Skip the role-toggle so an element marked BOTH
        // role="alert" and .js-a11y-alert (matched by both the DOMReady
        // sweep and the _init() sweep) doesn't double-toggle — which some
        // screen readers surface as a double-announcement.
        if ($el.data('scmAnnounceText') !== undefined) {
            return;
        }
        _captureOriginal($el);
        $el.removeAttr('role');
        setTimeout(function () {
            $el.attr('role', 'alert');
        }, ALERT_DELAY);
    }

    // Idempotent — a second call after the first is a no-op, so both _prime
    // (at DOMReady) and _alert (defensive fallback for dynamic alerts) can
    // call it without worrying about which fired first. Skips empty
    // elements: caching an empty string as the "original" would let a
    // later no-message _alert call render nothing and stay silent to AT —
    // worse than not caching and letting the cache stay undefined until
    // the first meaningful content is seen.
    function _captureOriginal($el) {
        if ($el.data('scmAnnounceText') !== undefined) {
            return;
        }
        if ($.trim($el.text()).length === 0) {
            return;
        }
        $el.data('scmAnnounceText', $el.html());
    }
})(jQuery);
